import React, { useEffect, useRef, useState } from 'react';
// Data
import { faqsArray } from '../../utils/data/FaqData';

function FaqComponent() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className='grid bg-colour2'>
      <div className='grid text-colour1 gap-10 md:gap-10 px-6 sm:px-8 md:px-12 lg:px-24 py-6 lg:pb-12 lg:container lg:mx-auto'>
        {/* Text */}
        <section className='overflow-hidden text-center'>
          <div>
            <h6 className='font-bold text-4xl'>FAQ</h6>
          </div>
        </section>

        {/* Questions */}
        <section className='grid gap-2'>
          {faqsArray.map((faq, index) => (
            <div
              key={index}
              className='border-b border-colour5 border-solid pb-1'
            >
              <button
                className='w-full text-left py-1 font-semibold md:text-base flex justify-between items-center'
                onClick={() => toggleFaq(index)}
              >
                {faq.question}
                <span>{openIndex === index ? '▲' : '▼'}</span>
              </button>
              {openIndex === index && (
                <p
                  className='text-sm text-colour5 py-2'
                  dangerouslySetInnerHTML={{ __html: faq.answer }}
                ></p>
              )}
            </div>
          ))}
        </section>
      </div>
    </section>
  );
}

export default FaqComponent;
